var map = {
	"./01.png": 295,
	"./01@2x.png": 106,
	"./02.png": 296,
	"./02@2x.png": 107,
	"./03.png": 297,
	"./03@2x.png": 108,
	"./Boston_University_logo.svg": 1145,
	"./MIT_logo.svg": 1146,
	"./penn_logo.svg": 1147,
	"./workspace.svg": 299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1144;